import React from 'react';
import { Shimmer, ShimmerElementType } from '@fluentui/react';

const audienceShimmerElement = [
  { type: ShimmerElementType.line, width: 200, height: 100 },
  { type: ShimmerElementType.gap, width: '2%', height: 100 },
  { type: ShimmerElementType.line, width: 200, height: 100 },
  { type: ShimmerElementType.gap, width: '100%', height: 100 },
];

export const AudienceSignalShimmer = () => (
  <div style={{ marginTop: 20 }}>
    <Shimmer shimmerElements={audienceShimmerElement} />
  </div>
);
